import { Container } from '@/components/base/container'
import { Skeleton } from '@/components/base/skeleton'
import { SingleColumnPage } from '@/components/page-layout'

export const OrderDetailSkeleton = () => (
	<SingleColumnPage>
		<div className='space-y-6'>
			{/* Header with title and status */}
			<div className='flex items-center justify-between'>
				<div className='flex items-center gap-4'>
					<Skeleton className='h-10 w-48' />
					<Skeleton className='h-6 w-20 rounded-full' />
				</div>
				<Skeleton className='h-9 w-32' />
			</div>

			{/* Order items */}
			<Container>
				<div className='p-6'>
					<Skeleton className='mb-4 h-6 w-32' />
					<div className='space-y-4'>
						{Array.from({ length: 3 }).map((_, i) => (
							<div key={i} className='flex items-center gap-4'>
								<Skeleton className='h-16 w-16 rounded' />
								<div className='flex-1 space-y-2'>
									<Skeleton className='h-4 w-3/4' />
									<Skeleton className='h-3 w-1/2' />
								</div>
								<Skeleton className='h-4 w-20' />
							</div>
						))}
					</div>
				</div>
			</Container>

			{/* Summary section */}
			<Container>
				<div className='p-6'>
					<Skeleton className='mb-4 h-6 w-24' />
					<div className='space-y-3'>
						{Array.from({ length: 4 }).map((_, i) => (
							<div key={i} className='flex items-center justify-between'>
								<Skeleton className='h-4 w-24' />
								<Skeleton className='h-4 w-16' />
							</div>
						))}
					</div>
				</div>
			</Container>

			{/* Payments section */}
			<Container>
				<div className='p-6'>
					<Skeleton className='mb-4 h-6 w-28' />
					<div className='space-y-3'>
						{Array.from({ length: 2 }).map((_, i) => (
							<div key={i} className='flex items-center justify-between'>
								<Skeleton className='h-4 w-32' />
								<Skeleton className='h-4 w-20' />
							</div>
						))}
					</div>
				</div>
			</Container>
		</div>
	</SingleColumnPage>
)
